import React, { useCallback } from 'react';
import TreeViewItem from './components/tree-view-item';
const TreeViewItemContainer = ({
  node,
  isOpen,
  onToggle,
  isDragging,
  isDropTarget,
  itemsDepthMap,
  onItemClick,
}) => {
  const handleClick = useCallback(() => {
    if (node.data) {
      if (node.data.droppable) {
        onToggle();
      }

      onItemClick(node.data);
    }
  }, [node.data, onToggle, onItemClick]);

  if (!node.data) {
    return null;
  }

  const item = node.data;
  const isCollapsed = item.droppable && !isOpen;
  const draggable = !item.state?.isDisabled;
  const dragDepthEntry = itemsDepthMap.get(node.id);
  const hasChildren = Boolean(dragDepthEntry?.maxChildDepth);

  let { iconGlyph } = item;
  let hoverIconGlyph;
  let selected;

  if (draggable) {
    iconGlyph = iconGlyph || 'drag-icon';
    hoverIconGlyph = 'drag-icon';
  }

  if (item.droppable && hasChildren) {
    iconGlyph = isCollapsed ? 'small-right-arrow' : 'bottom';
  } else {
    selected = item.state?.isSelected;
  }

  return (
    <div className="ws-ui-tree-view-item-container__wrapper">
      <TreeViewItem
        iconGlyph={iconGlyph}
        hoverIconGlyph={hoverIconGlyph}
        selected={selected}
        customIconGlyph={item.customIconGlyph}
        iconType={item.iconType}
        actions={item.actions}
        title={item.title}
        description={item.description}
        draggable={draggable}
        isEmpty={isDragging}
        highlighted={isDropTarget}
        disabled={item.state?.isDisabled}
        onClick={handleClick}
      />
    </div>
  );
};

export default React.memo(TreeViewItemContainer);
